export const DEFAULT_WAITLIST_HINT =
  "Angebote mit dem Vermerk «Warteliste» sind keine feste Anmeldung. Wir setzen Ihr Kind dafür auf die Warteliste und melden uns, sobald ein Platz frei ist.";

export const DEFAULT_WAITLIST_ZIP_CODE_MESSAGE =
  "Ihr Wohnort liegt ausserhalb unseres Einzugsgebiets. Sie können Ihr Kind nur auf die Warteliste setzen.";
